// extracted by mini-css-extract-plugin
module.exports = {"container":"_2NAv-cn-u0DayvjjKwrl5n","groupsList":"u7FLTkbhOeJgT1fGRv-Wu"};